import React from "react";
import { useTranslation } from "react-i18next";
import { locales, setLocale } from "./paraglide/runtime";

/**
 * Integrate paraglide with i18next.
 * Reacts to language changes and updates paraglide locale accordingly.
 */
export const ParaglideProvider = ({
	children,
}: {
	children: React.ReactNode;
}) => {
	const { i18n } = useTranslation();
	const locale = i18n.resolvedLanguage ?? "en";
	React.useEffect(() => {
		if (locales.includes(locale as any)) {
			setLocale(locale as any, { reload: false });
		} else {
			setLocale("en", { reload: false });
		}
	}, [locale]);

	return <React.Fragment key={locale}>{children}</React.Fragment>;
};
